<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}处置</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <ApproveInfo style="margin-bottom:20px;" ref="approveInfo" v-if="showWorkFlowInfo" title="处置意见" resultName="处置资产" reasonName="处置建议" @change="approveInfoChange"></ApproveInfo>

        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">处置基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="处置单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成处置单号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期" prop="createdTime">
                <el-date-picker disabled v-model="form.createdTime" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="系统默认为当前日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产维度" prop="category">
                <el-select :disabled="!editMode" v-model="form.category" style="width: 90%" filterable placeholder="请选择资产维度" @change="AssetTypeChange">
                  <el-option v-for="item in AssetTypeOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处置维度" prop="disposalRange">
                <el-select :disabled="!editMode" v-model="form.disposalRange" style="width: 90%" filterable placeholder="请选择处置维度" @change="disposalRangeChange">
                  <el-option v-for="item in AssetDisposaRangeOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="form.disposalRange == 0">
              <el-form-item label="原库房" prop="warehouseName">
                <el-select :disabled="!editMode" v-model="form.warehouseName" style="width: 90%" filterable placeholder="请选择原库房" :filter-method="
                    form.category == 1 ? getWarehouses : getNoneWarehouses
                  " @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-else>
              <el-form-item label="原科室" prop="deptName">
                <el-select :disabled="!editMode" v-model="form.deptName" style="width: 90%" filterable placeholder="请选择原科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="form.disposalRange == 0">
              <el-form-item label="库房管理员" prop="warehouseManagerName">
                <el-input disabled v-model="form.warehouseManagerName" placeholder="系统自动带出库管员" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-else>
              <el-form-item label="科室负责人" prop="deptManagerName">
                <el-select :disabled="!editMode" v-model="form.deptManagerName" style="width: 90%" filterable placeholder="请选择科室负责人" :filter-method="GetDeptUsers" @change="depUserChange">
                  <el-option v-for="item in STATIC_DeptUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处置人" prop="userName">
                <el-select :disabled="!editMode" v-model="form.userName" style="width: 90%" filterable placeholder="请选择处置人" :filter-method="getUsers" @change="userChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处置日期" prop="date">
                <el-date-picker disabled v-model="form.date" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="系统默认为当前日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总数量" prop="toTalNumber">
                <el-input-number disabled v-model="form.toTalNumber" :min="0" :precision="2" :controls="false" placeholder="根据详细信息数量求和汇总" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总金额" prop="totalAmount">
                <el-input-number disabled v-model="form.totalAmount" :min="0" :precision="4" :controls="false" placeholder="根据详细信息金额求和汇总" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="建议处置方式" prop="disposalMethod">
                <el-select :disabled="!editMode" v-model="form.disposalMethod" style="width: 90%" filterable placeholder="请选择建议处置方式">
                  <el-option v-for="item in AssetDisposaTypeOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 退库详情table -->
        <AssetInfoEdit ref="AssetInfoEditRef" :details="form.details" :canEdit="editMode" typeName="处置" :ParentForm="form" :FixedAssetParam="fixedAssetParam" @autoTotalAmount="autoTotalAmount" :moreColumn="moreColumn" :isNoneAsset="form.category == 0" :isRepeatMethod="isRepeatMethod" isRepeatMsg="当前处置信息已存在，请去子表编辑！" :mustCard="true">
          <el-table-column label="处置价值" slot="DisposalValue" width="120px" align="center">
            <template slot-scope="scope">
              <el-input-number v-if="showWorkFlowInfo && form.result == 1" v-model="scope.row.value" :min="0" :precision="0" :controls="false" placeholder="处置价值" style="width:100%"></el-input-number>
              <label v-else>{{ scope.row.value }}</label>
            </template>
          </el-table-column>
          <el-table-column label="处置原因" slot="DisposalReason" width="120px" align="center">
            <template slot-scope="scope">
              <el-input v-if="showWorkFlowInfo && form.result == 1" v-model="scope.row.reason" placeholder="处置原因" style="width:100%"></el-input>
              <label v-else>{{ scope.row.reason }}</label>
            </template>
          </el-table-column>
        </AssetInfoEdit>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetDisposalById,
  SaveDisposal,
  RejectDisposal,
  GetAssetInStockById,
} from "@/api";
import {
  AssetTypeOptions,
  AssetDisposaRangeOptions,
  AssetDisposaTypeOptions,
} from "@/enum";
import AssetInfoEdit from "@/components/asset-into-edit";
import ApproveInfo from "@/components/approve-info";
export default {
  mixins: [GetDataMixin],
  components: { AssetInfoEdit, ApproveInfo },
  /** 定义属性 */
  data () {
    return {
      form: {},
      AssetTypeOptions: AssetTypeOptions,
      AssetDisposaRangeOptions: AssetDisposaRangeOptions,
      AssetDisposaTypeOptions: AssetDisposaTypeOptions,
      rules: {
        category: [
          { required: true, message: "资产维度不能为空", trigger: "blur" },
        ],
        disposalRange: [
          { required: true, message: "处置维度不能为空", trigger: "blur" },
        ],
        deptName: [
          { required: true, message: "原科室不能为空", trigger: "blur" },
        ],
        deptManagerName: [
          { required: true, message: "科室负责人不能为空", trigger: "blur" },
        ],
        warehouseName: [
          { required: true, message: "原库房不能为空", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "处置人不能为空", trigger: "blur" },
        ],
        date: [
          { required: true, message: "处置日期不能为空", trigger: "blur" },
        ],
        disposalMethod: [
          { required: true, message: "建议处置方式不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectDisposal,
      applyDetails: [],
      fixedAssetParam: {},
      moreColumn: [{ slot: "DisposalValue" }, { slot: "DisposalReason" }],
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetDisposalById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;

        this.$refs.AssetInfoEditRef.getFixedAssetList("");

        this.initWorkFlowProperty(this.form);
        if (!this.form.details) {
          this.form.details = [];
        }
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
        if (this.form.outStockType == 0) {
          this.deptWarehouseOutChange(this.form.warehouseOutStockId);
        }
        this.autoTotalAmount();
      });
    },
    // 保存
    submit () {
      this.form.details = this.$refs.AssetInfoEditRef.getDetails();
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveDisposal(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        });
      });
    },
    /**
     * 初始化表单数据
     */
    resetForm () {
      this.form = {
        category: 1,
        categoryName: "",
        outStockType: 0,
        supplierId: "",
        supplierName: "",
        warehouseId: "",
        warehouseName: "",
        state: 0,
        details: [],
        deptId: "",
        deptName: "",
        applyUserId: this.userInfo.id,
        applyUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        disposalRange: 0,
        reason: "",
        remark: "",
        orgCode :sessionStorage.getItem('orgId')
      };
      this.$refs.AssetInfoEditRef.getFixedAssetList("");
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    autoTotalAmount (e) {
      let toTalNumber = 0;
      let totalAmount = 0;
      this.form.details = e;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        toTalNumber = toTalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
        if (this.form.disposalMethod == 3) {
          e[index].unBillNumber = element.number;
          e[index].unBillAmount = element.amount;
        }
      });
      this.form.toTalNumber = toTalNumber;
      this.form.totalAmount = totalAmount;
      if (this.form.disposalMethod == 3) {
        this.form.unBillNumber = totalNumber;
        this.form.unBillAmount = totalAmount;
      }
    },

    // ====================表单变化事件======================
    dutyDeptChange (val) {
      this.form.dutyDeptId = val;
    },
    deptChange (val) {
      this.form.deptId = val;
      this.GetDeptUsers();
      this.$set(this.form, "deptManagerId", "");
      this.$set(this.form, "deptManagerName", "");
      if (this.form.disposalRange == 1) {
        this.fixedAssetParam = Object.assign(this.fixedAssetParam, {
          deptId: this.form.deptId,
          warehouseId: "",
        });
      }
      this.$refs.AssetInfoEditRef.getAssetCards("");
      window.setTimeout(() => {
        this.$refs.AssetInfoEditRef.getFixedAssetList("");
      }, 200);
    },
    depUserChange (val) {
      this.form.deptManagerId = val;
    },
    dutyUserChange (val) {
      this.form.dutyUserId = val;
    },
    userChange (val) {
      this.form.userId = val;
    },
    AssetTypeChange (val) {
      if (this.form.category == 1) {
        this.getWarehouses().then((res) => {
          if (res.length == 1 && this.form.disposalRange == 0) {
            this.warehouseChange(res[0].id);
            this.form.warehouseName = res[0].no + " " + res[0].name;
          } else {
            this.form.warehouseName = "";
            this.warehouseChange(null);
          }
        });
        window.setTimeout(() => {
          this.$refs.AssetInfoEditRef.getFixedAssetList("");
        }, 200);
      } else {
        this.getNoneWarehouses().then((res) => {
          if (res.length == 1 && this.form.disposalRange == 0) {
            this.warehouseChange(res[0].id);
            this.form.warehouseName = res[0].no + " " + res[0].name;
          } else {
            this.form.warehouseName = "";
            this.warehouseChange(null);
          }
        });
      }
    },
    /**
     * 处置维度选择
     */
    disposalRangeChange (val) { },
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
        if (this.form.disposalRange == 0) {
          this.fixedAssetParam = Object.assign(this.fixedAssetParam, {
            deptId: "",
            warehouseId: this.form.warehouseId,
            StocktakingCategory: 1,
          });
          window.setTimeout(() => {
            this.$refs.AssetInfoEditRef.getFixedAssetList("");
          }, 200);
        }
      }
    },
    deptWarehouseOutChange (val) {
      this.form.warehouseOutStockId = val;
      let item = this.STATIC_WarehouseOutStocks.data.find((e) => e.id == val);
      // GetDeptClaimById({ id: val }).then((res) => {
      //   this.form.deptClaimNo = res.returnData.no;
      //   this.form.claimDeptName = res.returnData.deptName;
      //   this.form.claimDeptId = res.returnData.deptId;
      //   this.form.claimUserId = res.returnData.applyUserId;
      //   this.form.claimUserName = res.returnData.applyUserName;
      //   this.form.warehouseId = res.returnData.warehouseId;
      //   this.form.warehouseName = res.returnData.warehouseName;
      //   this.form.warehouseManagerId = res.returnData.warehouseManagerId;
      //   this.form.warehouseManagerName = res.returnData.warehouseManagerName;

      //   this.applyDetails = res.returnData.details;

      //   this.$refs.AssetInfoEditRef.getFixedAssetList("");
      // });
    },
    inStockChange (val) {
      this.form.assetInStockId = val;
      GetAssetInStockById({ id: val }).then((res) => {
        this.form.warehouseId = res.returnData.warehouseId;
        this.form.warehouseName = res.returnData.warehouseName;
        this.form.warehouseManagerId = res.returnData.warehouseManagerId;
        this.form.warehouseManagerName = res.returnData.warehouseManagerName;

        this.$refs.AssetInfoEditRef.getFixedAssetList("");
      });
    },
    outStockTypeChange () {
      this.form.warehouseOutStockId = "";
      this.form.warehouseOutStocksNo = "";
      this.form.assetInStockId = "";
      this.form.assetInStockNo = "";
      this.applyDetails = [];
      this.form.details = [];
    },

    GetDeptUsers (keyWord) {
      this.getDeptUsers(this.form.deptId, keyWord).then((res) => {
        window.console.log(res);
      });
    },
    isRepeatMethod (arr, row) {
      let item = arr.find(
        (e) =>
          e.$index != row.$index &&
          e.assetId == row.assetId &&
          e.price == row.price &&
          e.locationName == row.locationName &&
          e.assetSource == row.assetSource &&
          e.packDesc == row.packDesc &&
          e.manufacturerId == row.manufacturerId &&
          e.certId == row.certId &&
          e.brandId == row.brandId
      );
      if (item) {
        return true;
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () { },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
      if (query.claimId) {
        this.form.deptClaimId = query.claimId;

        this.deptWarehouseOutChange(query.claimId);
      }
    }

    this.getUsers("");
    this.getDepts("");
    this.getWarehouses("");
    // this.getFixedAssetList('')

    this.getDeptClaims("");
    this.getAssetInStocks("");
    this.getWarehouseOutStocks("");
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
